// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___dZVlS","root_md":"style-module__root_md___sA04S","root__label":"style-module__root__label___ANrYL","root_sm":"style-module__root_sm___lgUW4"};
    if(module.hot) {
      // 1697460472198
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  